module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-9.60b802c8.jpg";